import React from 'react';

interface PoofyPayMarkProps {
  size?: 'sm' | 'md';
  className?: string;
}

const SIZES = {
  sm: { mark: 20, gap: 8, font: 13, letterSpacing: '-0.018em' },
  md: { mark: 24, gap: 10, font: 15, letterSpacing: '-0.02em' },
} as const;

export const PoofyPayMark: React.FC<PoofyPayMarkProps> = ({ size = 'md', className = '' }) => {
  const dims = SIZES[size];
  return (
    <span
      className={`inline-flex items-center ${className}`}
      style={{ gap: dims.gap, lineHeight: 1 }}
      aria-label='Poofy Pay'
    >
      <svg
        width={dims.mark}
        height={dims.mark}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden='true'
      >
        <rect x='1' y='1' width='22' height='22' rx='6' fill='var(--pp-action)' />
        <path
          d='M8 6.5h5.2a3.5 3.5 0 0 1 0 7H10v4H8v-11Zm2 5h3.05a1.5 1.5 0 0 0 0-3H10v3Z'
          fill='#FFFFFF'
        />
        <rect x='6.5' y='13.5' width='11' height='1.4' rx='0.7' fill='#FFFFFF' fillOpacity='0.85' />
      </svg>
      <span
        style={{
          color: 'var(--pp-text)',
          fontFamily: "'Inter', system-ui, sans-serif",
          fontWeight: 600,
          fontSize: dims.font,
          letterSpacing: dims.letterSpacing,
        }}
      >
        Poofy Pay
      </span>
    </span>
  );
};

export default PoofyPayMark;
